import ChevronRight from "/public/images/icons/chevronRight.svg?react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import IncidentIcon from "/public/images/icons/incidentIconWhite.svg?react";

export default function GuestBandCard({ band }) {

  const cardContent = (
    <div
      className={`flex flex-col border-[#E3E3E3] bg-white border rounded-[8px] py-4 pl-6 pr-[6px] relative`}
    >
      {band?.HistoricalIncidentCount > 0 && (
        <div className="bg-sportsRed px-[12px] py-[7px] absolute left-0 top-[55px] transform -translate-y-1/2 rounded-r-[6px]">
          <IncidentIcon />
        </div>
      )}

      <div className="flex cursor-pointer flex-row w-full justify-between items-center">
        <div className="flex flex-row gap-y-5 gap-x-4 justify-center">
          <img className='object-cover w-[74px] h-[62px]' src={band?.BandImageURL} width="74" height="62" />
          
          <div className="flex flex-col gap-1 justify-center">
            <h4 className=" text-black">{band?.ParticipantName}</h4>
            <p className="text-[14px] text-black mb-2">{band?.FriendlyName}</p>
            <p className="text-[#1E1E1E] font-poppins text-[12px] leading-[24px] capitalize font-semibold px-3 bg-sportsLightGrey rounded self-start">{band?.BandStateVerbose}</p>
          </div>
        </div>
        <div className="">
          <ChevronRight className="fill-black transition-all cursor-pointer"/>
        </div>
      </div>
    </div>
  );

  return (
    <Link to={`/participant/${band?.ParticipantId}`} state={{ user: band }}>
      {cardContent}
    </Link>
  )
}

GuestBandCard.propTypes = {
  band: PropTypes.object.isRequired,
};